<template>
  <div class="bgs">
        <Header></Header>
        <NavPersonal></NavPersonal>
        <Footer></Footer>
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import NavPersonal from "../components/NavPersonal.vue";
export default {
    data(){
        return{

        }
    },
  components: {
    Header,
    Footer,
    NavPersonal
  },
}
</script>

<style scoped>
.bgs{
    background:#F5F7F9;
}
</style>